// Polyfills
import 'core-js/es6/symbol';
import 'core-js/fn/object/assign';
import 'core-js/fn/array/iterator';

// jQuery plugins
import './globals/jquery';
import 'jquery-trend';
import 'jquery-revealer';

import $ from 'jquery';
import $script from 'scriptjs';

import './globals/flickity-ios-fix';
import fitvids from 'fitvids';

// RTE
import RTE from './globals/RTE';

// Google maps
import './globals/google-maps';

// Template imports
import Account from './templates/Account';
import Index from './templates/Index';

// Section imports
import Sections from './Sections';
import ContactbarStaticSection from './sections/ContactbarStaticSection';
import DynamicBlogPosts from './sections/DynamicBlogPosts';
import DynamicFeaturedProducts from './sections/DynamicFeaturedProducts';
import DynamicInstagram from './sections/DynamicInstagram';
import DynamicSlideshow from './sections/DynamicSlideshow';
import DynamicTwitter from './sections/DynamicTwitter';
import DynamicVideo from './sections/DynamicVideo';
import GiftCardStaticSection from './sections/GiftCardStaticSection';
import HeaderStaticSection from './sections/HeaderStaticSection';
import MobileCollectionsDynamicSection from './sections/MobileCollectionsDynamicSection';
import SearchStaticSection from './sections/SearchStaticSection';
import StaticArticle from './sections/StaticArticle';
import StaticBlog from './sections/StaticBlog';
import StaticCart from './sections/StaticCart';
import StaticCollection from './sections/StaticCollection';
import StaticProduct from './sections/StaticProduct';

const sections = new Sections();

sections.register('dynamic-blog-posts', section => new DynamicBlogPosts(section));
sections.register('dynamic-instagram', section => new DynamicInstagram(section));
sections.register('dynamic-mobile-collections', section => new MobileCollectionsDynamicSection(section));
sections.register('dynamic-slideshow', section => new DynamicSlideshow(section));
sections.register('dynamic-twitter', section => new DynamicTwitter(section));
sections.register('dynamic-video', section => new DynamicVideo(section));
sections.register('static-blog', section => new StaticBlog(section));
sections.register('static-collection', section => new StaticCollection(section));
sections.register('static-contactbar', section => new ContactbarStaticSection(section));
sections.register('static-header', section => new HeaderStaticSection(section));
sections.register('static-search-results', section => new SearchStaticSection(section));
sections.register('static-article', section => new StaticArticle(section));

// Load sections that require the Shopify API
$script($('[data-scripts]').data('shopify-api-url'), () => {
  sections.register('dynamic-featured-products', section => new DynamicFeaturedProducts(section));
  sections.register('static-product', section => new StaticProduct(section));
});

// Cart
$script($('[data-scripts]').data('shopify-cart-url'), () => {
  sections.register('static-cart', section => new StaticCart(section));
});

// Giftcard
$script($('[data-scripts]').data('shopify-qrcode'), () => {
  sections.register('static-giftcard', section => new GiftCardStaticSection(section));
});

fitvids();
new Account();
new Index();
new RTE();
